import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import {Modal} from "react-bootstrap";

let source = axios.CancelToken.source();

class Allocate_cost_mgt_v2 extends Component {
    constructor() {
        super();
        this.state = {
            vehs: [],
            vehsorginal: null,
            vehsorginall: false,
            txtsearch: '',

            cushow2:false,
            modal_type:'',
            actfuelqtyempty:'',
            actprediemempty:'',
            acthandlefeeempty:'',
            actfuelqtyload:'',
            actpredieload:'',
            acthandlefeeload:'',

            fuelqtyempty:'',
            prediemempty:'',
            handlefeeempty:'',
            fuelqtyload:'',
            predieload:'',
            handlefeeload:'',
            remark:'',
            allocation_cost_approval_id:"-1",
        }
    }

    async componentDidMount() {
        this.get_allocation_for_cost_manage_v2();
    }

    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    inputmgt_fitler = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
        if (this.state.vehsorginall) {
            let temp = this.state.vehsorginal.datas;
            if (value != "") {
                temp = temp.filter(v => {
                    if (v.plate_no.toUpperCase().includes(value.toUpperCase())) {
                        return value;
                    }
                })
            }
            this.setState({
                vehs: temp,
            })
        }
    }
    get_allocation_for_cost_manage_v2 = () => {
        this.setState({
            vehs: [],
            vehsorginal: null,
            vehsorginall: false,
            txtsearch: '',

            cushow2:false,
            modal_type:'',
            actfuelqtyempty:'',
            actprediemempty:'',
            acthandlefeeempty:'',
            actfuelqtyload:'',
            actpredieload:'',
            acthandlefeeload:'',

            fuelqtyempty:'',
            prediemempty:'',
            handlefeeempty:'',
            fuelqtyload:'',
            predieload:'',
            handlefeeload:'',
            remark:'',
            allocation_cost_approval_id:"-1",
        });
        let baseurl = myconfig.get_allocation_for_cost_manage_v2;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            vehs: [],
            vehsorginal: null,
            vehsorginall: false,
            txtsearch: '',

            fright: false,
            frightno: "",
            assignment:null,

            openorder: false,
            openordersorginal: null,
            openordersorginall: false,
            orders: [],
            txtsearch_order: '',
            allocation_id: '',

            assignshow:false,
            wizard:0,
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            order_id: this.state.order_id,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    vehs: res.data.datas,
                    vehsorginal: res.data,
                    vehsorginall: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    tabledata = () => {
        let count = 0;
        let retdata = null;
        if (this.state.vehsorginal) {
            retdata = this.state.vehs.map(value => {
                let req=null
                let edit=null
                let del=null
                if(this.state.vehsorginal.usermatrix.update &&
                    value.type=="NA")
                    req=<td>
                        <a href="" onClick={(event => this.showcu2(event, value.id,"request"))}>Request</a>
                    </td>
                else
                    req=<td></td>
                if(this.state.vehsorginal.usermatrix.update &&
                    value.type=="request")
                    edit=<td>
                        <a href="" onClick={(event => this.showcu2(event, value.id,"edit",value.allocation_cost_approval_id))}>Edit</a>
                    </td>
                else
                    edit=<td></td>
                if(this.state.vehsorginal.usermatrix.delete &&
                    value.type=="request")
                    del=<td>
                        <a href="" onClick={(event => this.submitcu2_del(event, value.allocation_cost_approval_id))}>Delete</a>
                    </td>
                else
                    del=<td></td>
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    {req}
                    {edit}
                    {del}
                    <td>{value.plate_no}</td>
                    <td>{value.status}</td>
                    <td>{value.dri_name}</td>
                    <td>{value.dri_phoneno}</td>
                    <td>{value.tra_plateno}</td>
                    <td>{value.actfuelqtyempty}</td>
                    <td>{value.actfuelqtyload}</td>
                    <td>{value.actprediemempty}</td>
                    <td>{value.actpredieload}</td>
                    <td>{value.acthandlefeeempty}</td>
                    <td>{value.acthandlefeeload}</td>
                    <td>{value.fuelqtyempty}</td>
                    <td>{value.fuelqtyload}</td>
                    <td>{value.prediemempty}</td>
                    <td>{value.predieload}</td>
                    <td>{value.handlefeeempty}</td>
                    <td>{value.handlefeeload}</td>
                    <td>{value.req_by}</td>
                    <td>{value.req_date}</td>
                    <td>{value.req_remark}</td>
                    <td>{value.app_by}</td>
                    <td>{value.app_date}</td>
                    <td>{value.app_remark}</td>
                    <td>{value.status2}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }
    showcu2 = (event, id = -1,modal_type,allocation_cost_approval_id=-1) => {
        event.preventDefault()
        let baseurl = myconfig.get_allocation_for_cost_manage_v2_single;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            allocateveh_id: id,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                if (res.data.data == null) {
                    Swal.fire({
                        title: 'Error!',
                        text: "No data found",
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    this.setState({
                        id: id,
                        cushow2: true,
                        modal_type:modal_type,
                        actfuelqtyempty: res.data.data.actfuelqtyempty,
                        actprediemempty: res.data.data.actprediemempty,
                        acthandlefeeempty: res.data.data.acthandlefeeempty,
                        actfuelqtyload: res.data.data.actfuelqtyload,
                        actpredieload: res.data.data.actpredieload,
                        acthandlefeeload: res.data.data.acthandlefeeload,
                        fuelqtyempty: res.data.data.fuelqtyempty,
                        prediemempty: res.data.data.prediemempty,
                        handlefeeempty: res.data.data.handlefeeempty,
                        fuelqtyload: res.data.data.fuelqtyload,
                        predieload: res.data.data.predieload,
                        handlefeeload: res.data.data.handlefeeload,
                        allocation_cost_approval_id:allocation_cost_approval_id,
                        remark:res.data.data.req_remark,
                    })
                }
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    hidecu2 = () => {
        this.setState({
            cushow2: false,
        })
    }
    modalcu2 = () => {
        let header="Cost Managment Request";
        let buttonexe=  <button type="submit" className="btn btn-primary"
                                onClick={this.submitcu2_req}>Request
        </button>
        if(this.state.modal_type=="edit"){
            header="Cost Managment Edit";
            buttonexe=  <button type="submit" className="btn btn-primary"
                                onClick={this.submitcu2_edit}>Update
            </button>
        }
        return (<Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.cushow2}
                onHide={this.hidecu2}>
                <Modal.Header><h4>{header}</h4></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">Actual Data</h3>
                                </div>
                                <form>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Fuel Qty Empty</label>
                                                    <input disabled={true} className="form-control" type="text" name="actfuelqtyempty" onChange={this.inputmgt} value={this.state.actfuelqtyempty}/>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Fuel Qty Loaded</label>
                                                    <input disabled={true} className="form-control" type="text" name="actfuelqtyload" onChange={this.inputmgt} value={this.state.actfuelqtyload}/>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Per Diem Empty</label>
                                                    <input disabled={true} className="form-control" type="text" name="actprediemempty" onChange={this.inputmgt} value={this.state.actprediemempty}/>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Per Diem Loaded</label>
                                                    <input disabled={true} className="form-control" type="text" name="actpredieload" onChange={this.inputmgt} value={this.state.actpredieload}/>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Handling Fee Empty</label>
                                                    <input disabled={true} className="form-control" type="text" name="acthandlefeeempty" onChange={this.inputmgt} value={this.state.acthandlefeeempty}/>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Handling Fee Loaded</label>
                                                    <input disabled={true} className="form-control" type="text" name="acthandlefeeload" onChange={this.inputmgt} value={this.state.acthandlefeeload}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">Request Data</h3>
                                </div>
                                <form>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Fuel Qty Empty</label>
                                                    <input  className="form-control" type="text" name="fuelqtyempty" onChange={this.inputmgt} value={this.state.fuelqtyempty}/>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Fuel Qty Loaded</label>
                                                    <input  className="form-control" type="text" name="fuelqtyload" onChange={this.inputmgt} value={this.state.fuelqtyload}/>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Per Diem Empty</label>
                                                    <input  className="form-control" type="text" name="prediemempty" onChange={this.inputmgt} value={this.state.prediemempty}/>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Per Diem Loaded</label>
                                                    <input  className="form-control" type="text" name="predieload" onChange={this.inputmgt} value={this.state.predieload}/>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Handling Fee Empty</label>
                                                    <input  className="form-control" type="text" name="handlefeeempty" onChange={this.inputmgt} value={this.state.handlefeeempty}/>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Handling Fee Loaded</label>
                                                    <input  className="form-control" type="text" name="handlefeeload" onChange={this.inputmgt} value={this.state.handlefeeload}/>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Remark</label>
                                                    <input  className="form-control" type="text" name="remark" onChange={this.inputmgt} value={this.state.remark}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        {buttonexe}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    submitcu2_req = (event) => {
        event.preventDefault()
        let baseurl = myconfig.req_cost_change;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            allocateveh_id: this.state.id,
            fuelqtyempty: this.state.fuelqtyempty,
            prediemempty: this.state.prediemempty,
            handlefeeempty: this.state.handlefeeempty,
            fuelqtyload: this.state.fuelqtyload,
            predieload: this.state.predieload,
            handlefeeload: this.state.handlefeeload,
            req_remark: this.state.remark,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                Swal.fire({
                    title: 'success!',
                    text: res.data.msg,
                    icon: 'success',
                    confirmButtonText: 'Okay'
                }).then(value => {
                    this.get_allocation_for_cost_manage_v2()
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    submitcu2_edit = (event) => {
        event.preventDefault()
        let baseurl = myconfig.req_cost_change_update;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            allocateveh_id: this.state.id,
            allocation_cost_approval_id: this.state.allocation_cost_approval_id,
            fuelqtyempty: this.state.fuelqtyempty,
            prediemempty: this.state.prediemempty,
            handlefeeempty: this.state.handlefeeempty,
            fuelqtyload: this.state.fuelqtyload,
            predieload: this.state.predieload,
            handlefeeload: this.state.handlefeeload,
            req_remark: this.state.remark,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                Swal.fire({
                    title: 'success!',
                    text: res.data.msg,
                    icon: 'success',
                    confirmButtonText: 'Okay'
                }).then(value => {
                    this.get_allocation_for_cost_manage_v2()
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    submitcu2_del = (event,allocation_cost_approval_id=-1) => {
        event.preventDefault()
        Swal.fire({
            title: 'Do you want to delete the request?',
            showDenyButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                let baseurl = myconfig.req_cost_change_delete;
                let redirecttologin = myconfig.redirecttologin;
                axios.post(baseurl, {
                    sid: window.localStorage.getItem("ntfms_sid"),
                    allocation_cost_approval_id:allocation_cost_approval_id,
                }, {cancelToken: source.token}).then(res => {
                    if (res.data.auth == false) {
                        window.localStorage.setItem("ntfms_sid", null);
                        window.localStorage.setItem("ntfms_username", null);
                        window.localStorage.setItem("ntfms_name", null);
                        var win = window.open(redirecttologin, "_self");
                    } else if (res.data.success == false) {
                        Swal.fire({
                            title: 'Error!',
                            text: res.data.msg,
                            icon: 'error',
                            confirmButtonText: 'Okay'
                        })
                    } else {
                        Swal.fire({
                            title: 'Success',
                            text: res.data.msg,
                            icon: 'success',
                            confirmButtonText: 'Okay'
                        }).then(value => {
                            this.get_allocation_for_cost_manage_v2()
                        })
                    }
                }).catch((e) => {
                    console.log(e.message);
                });
            } else if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info')
            }
        })
    }

    render() {
        let req=null
        let edit=null
        let del=null
        if(this.state.vehsorginall){
            if(this.state.vehsorginal.usermatrix.update)
                req=<th>Request</th>
            if(this.state.vehsorginal.usermatrix.update)
                edit=<th>Edit</th>
            if(this.state.vehsorginal.usermatrix.delete)
                del=<th>Delete</th>
        }
        return (
            <>
                <Nav type="allocate_cost_mgt_v2"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Cost Management V2</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Cost V2</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <input type="text" name="txtsearch" onChange={this.inputmgt_fitler}
                                                       className="form-control float-right" placeholder="Search"/>
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                        <table className="table table-head-fixed text-nowrap">
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                {req}
                                                {edit}
                                                {del}
                                                <th>Truck Plate #</th>
                                                <th>Truck Status</th>
                                                <th>Driver Name</th>
                                                <th>Driver Phone</th>
                                                <th>Trailer #</th>
                                                <th>(act) Fuel Qty Empty</th>
                                                <th>(act) Fuel Qty Load</th>
                                                <th>(act) Per Diem Empty</th>
                                                <th>(act) Per Diem Load</th>
                                                <th>(act) Handling Fee Empty</th>
                                                <th>(act) Handling Fee Load</th>
                                                <th>(req) Fuel Qty Empty</th>
                                                <th>(req) Fuel Qty Load</th>
                                                <th>(req) Per Diem Empty</th>
                                                <th>(req) Per Diem Load</th>
                                                <th>(req) Handling Fee Empty</th>
                                                <th>(req) Handling Fee Load</th>
                                                <th>Request By</th>
                                                <th>Request Date</th>
                                                <th>Request Remark</th>
                                                <th>Approved By</th>
                                                <th>Approved Date</th>
                                                <th>Approved Remark</th>
                                                <th>Status</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.tabledata()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/* /.card */}
                            </div>
                        </div>
                    </section>
                </div>
                {this.modalcu2()}
            </>
        )
    }
}

export default Allocate_cost_mgt_v2;
